import axios from "axios";
import { useQuery } from "react-query";
import { useGetUserInfo } from "hooks/useGetUserInfo";
import { END_POINT } from "config/environment";

export const QUERY_KEY_FOR_UNREAD_MESSAGES = "unread-message-count";

const getUnreadMessageCount = async (props: {
  token: string;
}): Promise<number> => {
  const url = `${END_POINT.BASE_URL}/v1/messages/unread-count`;
  const config = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${props.token}`,
    },
  };

  const res = await axios.get(url, config);
  return Number(res.data?.unread_count ?? 0);
};

export const useGetUnreadMessageCount = (enabled = true) => {
  const { token } = useGetUserInfo();

  return useQuery(
    [QUERY_KEY_FOR_UNREAD_MESSAGES, token],
    () => getUnreadMessageCount({ token }),
    {
      enabled: Boolean(token) && enabled,
      refetchInterval: 30_000,
      staleTime: 15_000,
    },
  );
};
